import { render, staticRenderFns } from "./InvestorList.vue?vue&type=template&id=cd974824&scoped=true&"
import script from "./InvestorList.vue?vue&type=script&lang=js&"
export * from "./InvestorList.vue?vue&type=script&lang=js&"
import style0 from "./InvestorList.vue?vue&type=style&index=0&id=cd974824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd974824",
  null
  
)

export default component.exports